import { createSelectors } from '@mri-platform/shared/entity';
import { Platform } from '../../models';

export const platformSelectors = createSelectors(Platform);
